/**
 * @constant INTEGER_FIELDS
 * @description Report fields that count something - samples, folds, trees, metres of block - and
 * are shown rounded. Three decimals on a sample count reads as precision the number does not have.
 * @memberof module:Bathymetry
 */
export const INTEGER_FIELDS = new Set([
  'n',
  'SCALE_M',
  'TREE_PREDICTOR_COUNT',
  'TREE_N_SAMPLES',
  'MODEL_TRAINED_SAMPLES',
  'CV_FOLDS',
  'CV_FOLDS_ASKED',
  'CV_BLOCK_M',
  'CV_N',
  'TREE_RF_N_TREES',
  'TREE_RF_VARS_PER_SPLIT',
  'TREE_RF_MIN_LEAF',
  'TREE_GBT_N_TREES',
  'TREE_GBT_MAX_NODES',
]);
/**
 * @constant LONG_FIELDS
 * @description Report fields whose value is a list rather than a number. Written out in full they
 * are wider than the panel and push every other row out of shape - the predictor list alone is
 * eighteen band names - so the row shows as much as fits and the whole value moves to the tooltip.
 * @memberof module:Bathymetry
 */
export const LONG_FIELDS = new Set(['TREE_PREDICTORS', 'TREE_ENSEMBLES']);

/**
 * @constant NO_DECIMAL_FIELDS
 * @description Report fields whose value is a word rather than a number - the model, the mission,
 * the CRS - shown exactly as they are stored.
 * @memberof module:Bathymetry
 */
export const NO_DECIMAL_FIELDS = new Set([
  'BDS_MODEL',
  'TREE_PREDICTOR_SET',
  'MODEL_SOURCE',
  'MODEL_TRAINED_ON',
  'TREE_GBT_LOSS',
  'CV_SCHEME',
  'CV_DEGENERATE',
  'MISSION',
  'IMAGE_SOURCE',
  'RUN_MODE',
  'TRAININGDATA_REDUCER',
  'CRS',
  'targetDate',
]);
/**
 * @constant DEPTH_PALETTE
 * @description The twenty steps the depth map is painted in, cyan at the surface to dark blue at
 * twenty metres. Written out rather than interpolated so the map, the legend and the PDF all read
 * the same colours from one place.
 * @memberof module:Bathymetry
 */
export const DEPTH_PALETTE = [
  '00ffff',
  '00f2f9',
  '00e4f2',
  '00d7ec',
  '00c9e5',
  '00bcdf',
  '00aed8',
  '00a1d2',
  '0094cb',
  '0086c5',
  '0079be',
  '006bb8',
  '005eb1',
  '0051ab',
  '0043a4',
  '00369e',
  '002897',
  '001b91',
  '000d8a',
  '000084',
];

/**
 * @constant PADDING_DAYS
 * @description How many days either side of an acquisition the gauge series is kept, so the tide
 * can be interpolated at that moment without carrying a multi-year file into Earth Engine.
 * @memberof module:Bathymetry
 */
export const PADDING_DAYS = 3;

/**
 * @constant ONE_DAY_MS
 * @description A day in milliseconds, for the window above.
 * @memberof module:Bathymetry
 */
export const ONE_DAY_MS = 86400000;
